<template>
    <div class="md-layout-item md-xsmall-size-100 md-medium-size-50" >
        <h4 class="card-title amentity_group_title">{{ amenityGroup.name }}</h4>
        <md-switch v-for="amenity in amenityGroup.items" :key="amenity.name" v-model="amenity.selected">{{ amenity.name }}</md-switch>
    </div>
</template>
<script>
    import IAmenityGroup from "@/ts/amenitiesSpec";
    
    export default {
        name: "AmenityGroup",
        props: {
            amenityGroup: IAmenityGroup
        }
    };
</script>
<style>
    .md-switch .md-switch-label {
        color: rgba(0, 0, 0, 0.8);
    }

    .amentity_group_title {
        min-height:25px;
    }
</style>
